import type { SaveStatus } from "@excalidraw-ms/shared";

interface SaveStatusIndicatorProps {
  status: SaveStatus;
  onRetry?: () => void;
}

const STATUS_CONFIG: Record<SaveStatus, { label: string; color: string; icon: string }> = {
  saved: { label: "Saved", color: "var(--exms-success)", icon: "✓" },
  saving: { label: "Saving…", color: "var(--color-gray-60)", icon: "⟳" },
  unsaved: { label: "Unsaved", color: "var(--exms-warning)", icon: "●" },
  error: { label: "Save failed", color: "var(--color-danger)", icon: "✗" },
  conflict: { label: "Conflict", color: "var(--color-danger)", icon: "⚠" },
  offline: { label: "Offline", color: "var(--color-gray-60)", icon: "◌" },
};

export default function SaveStatusIndicator({ status, onRetry }: SaveStatusIndicatorProps) {
  const config = STATUS_CONFIG[status];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.35rem",
        fontSize: 13,
        color: config.color,
        fontFamily: "system-ui, sans-serif",
        cursor: status === "error" && onRetry ? "pointer" : "default",
        userSelect: "none",
      }}
      onClick={status === "error" && onRetry ? onRetry : undefined}
      title={status === "error" ? "Click to retry" : config.label}
    >
      <span>{config.icon}</span>
      <span>{config.label}</span>
    </div>
  );
}
